import axios from "axios";
import cookie from "vue-cookie";

const state = {
	user: null,
	csrfToken: null,
	isAvatarLoading: false,
};
const getters = {
	user: (state) => {
		return state.user;
	},
	csrfToken: (state) => {
		return state.csrfToken;
	},
	isAvatarLoading: (state) => {
		return state.isAvatarLoading;
	},
};

const mutations = {
	setUser(state, payload) {
		state.user = payload;
	},
	setCsrfToken(state, payload) {
		state.csrfToken = payload;
	},
	setAvatar(state, payload) {
		state.user.avatar = payload;
	},
	setAvatarLoading(state, payload) {
		state.isAvatarLoading = payload;
	},
};

const actions = {
	async getUser({ commit }) {
		let success = false;
		await axios
			.get("users/me")
			.then((response) => {
				if (response.data && response.data.data) {
					let user = Object.assign({}, response.data.data);
					if (!user.name || user.name == "") {
						user.name = user.email;
					}
					commit("setUser", user);
					success = true;
				}
			})
			.catch((e) => {
				console.log("GET USER ERROR", e);
				success = false;
			});
		return success;
	},
	async updateUser({ commit }, data) {
		let success = false;
		await axios
			.patch("users/update", data)
			.then((response) => {
				console.log(response);
				if (response.data && response.data.data) {
					// No name hack
					let user = Object.assign({}, response.data.data);
					if (!user.name || user.name == "") {
						user.name = "No name";
					}
					commit("setUser", user);
					success = true;
				}
			})
			.catch((e) => {
				console.log("UPDATE USER ERROR", e);
				success = false;
			});
		return success;
	},
	async getCsrfToken() {
		let success = false;

		await axios
			.get("csrf-cookie")
			.then((response) => {
				console.log("CSRF COOKIE SUCCESS", response);
				success = false;
			})
			.catch(() => {
				success = false;
			});
		return success;
	},
	getCsrfCookie({ commit }) {
		let success = false;
		const token = cookie.get("XSRF-TOKEN");
		if (token) {
			commit("setCsrfToken", token);
			success = true;
		} else {
			console.log("CSRF cookie error:");
			success = false;
		}
		return success;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
